import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const putLunchMeal = async (mealData) => {
  const response = await axios.put(
    `${WiMuleSQL}/api/LunchMenu/PutLunchMeal`,
    mealData
  );
  console.log("PUT Message", response.data);
  return response.data;
};

export const usePutLunchMeal = () =>
  useMutation({
    mutationFn: putLunchMeal,
  });
